// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-cHh","newExpiryDate":"styles_newExpiryDate__1MQN-","footer":"styles_footer__1hkEq"};